<!-- <ckeditor
  formControlName="control"
  [(ngModel)]="editorData"
  [editor]="editor"
  [config]="defaultConfig"
></ckeditor> -->
<router-outlet> </router-outlet>
<app-loader></app-loader>
